import {postToNative} from "../utils/nativeBridge";

//登出機台：清掉 POS 帳號憑證後回登入頁（與 App.js 的登出一致）
export default function kioskLogout() {
  localStorage.removeItem("token");
  localStorage.removeItem("_ac");
  postToNative("logout");
  window.location.href = "/";
}
